export default __webpack_public_path__ + "media/images/rabbit_ui_conversation-f4906c3b8cb6732f33305ec18a99c06a.png";